import { render } from "./Trash.vue?vue&type=template&id=4efdd519"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"
script.render = render

export default script